// filepath: apps/web/src/features/admin/hmacKeys/DestructiveRotateDialog.tsx
//
// FR-UI-ADM-7 AC-10 / FR-UI-CORE-6 -- destructive-rotate confirmation
// dialog shown when a grace-period key is already present.
//
// The admin must explicitly proceed and the cancel button is the default.
// Re-confirms before opening the actual RotateKeyDialog.

import React from "react";
import { useTranslation } from "react-i18next";

interface DestructiveRotateDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onProceed: () => void;
}

export function DestructiveRotateDialog({
  open,
  onClose,
  onConfirm: _onConfirm,
  onProceed,
}: DestructiveRotateDialogProps): React.ReactElement | null {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div
      data-testid="destructive-rotate-dialog"
      className="hmac-keys-dialog hmac-keys-dialog--destructive"
      role="alertdialog"
      aria-modal="true"
    >
      <h2>{t("admin.webhooks.keys.destructive_rotate_title")}</h2>
      <p>{t("admin.webhooks.keys.destructive_rotate_warning")}</p>
      <div className="hmac-keys-dialog__actions">
        <button
          type="button"
          onClick={onClose}
          data-testid="destructive-rotate-cancel"
        >
          {t("admin.webhooks.keys.cancel_button")}
        </button>
        <button
          type="button"
          onClick={onProceed}
          className="hmac-keys-button--destructive"
          data-testid="destructive-rotate-proceed"
        >
          {t("admin.webhooks.keys.confirm_rotate_button")}
        </button>
      </div>
    </div>
  );
}
